import { Link, type LinkProps } from "react-router-dom";
import { prefetchRoute } from "@boundary/utils/prefetchRoute";

type PrefetchLinkProps = LinkProps & {
  prefetch?: boolean;
};

export function PrefetchLink({
  prefetch = true,
  onPointerEnter,
  onPointerDown,
  to,
  ...rest
}: PrefetchLinkProps) {
  return (
    <Link
      {...rest}
      to={to}
      onPointerEnter={(e) => {
        if (prefetch) prefetchRoute(to);
        onPointerEnter?.(e);
      }}
      onPointerDown={(e) => {
        if (prefetch) prefetchRoute(to);
        onPointerDown?.(e);
      }}
    />
  );
}


